import React from "react";
import PageHeader from "../../PageHeader";
import { ReactComponent as SubjectIcon } from "../../../images/subjectimage/subjecticon.svg";
import { ReactComponent as AddIcon } from "../../../images/pageheadingicon/addicon.svg";
import useStyles from "../../../../styles";
import ViewBatch from "./ViewBatch";
import { toast } from "react-toastify";
import BatchesInBulk from "../../../../BulkCSVFilder/BatchesInBulk.csv"

function Batch() {
  const classes = useStyles();

   const handleDownload = () => {
      const link = document.createElement("a");
      link.href = BatchesInBulk;
      link.setAttribute("download", "BatchesInBulk.csv");
  
      // Append to the document and trigger the download
      document.body.appendChild(link);
      link.click();
  
      // Check if the download started (link exists in document)
      if (document.body.contains(link)) {
        toast.success("Sample file for adding branches in bulk has been downloaded");
      } else {
        toast.error("Failed to download the bulk branches file. Please try again.");
      }
  
      // Clean up
      link.parentNode.removeChild(link);
    };

  const Heading = [
    {
      id: 1,
      pageicon:<SubjectIcon />,
      mainheading: "Batch",
      subhead: "Want to Add in Bulk ? ?",
      // downloadlink: "Download bulk Sample Files",
      addbtntext:"Create New Batch",
      addbtnicon: <AddIcon />,
       onDownload: handleDownload,
      addbtnstyle: "bluebtn",
      path:"/admin/addbatch",
      showDownloadButton: true,
    },
  ];
  return (
    <div className={`${classes.p1} ${classes.pb0}`}>
      <PageHeader Heading={Heading}/>
      <ViewBatch/>
    </div>
  );
}
export default Batch;